export const OK = "OK";
export const PENDING  = "PENDING";
export const LOG_ERROR = "LOG_ERROR";
export const VALUE_ERROR = "VALUE_ERROR";